import { IoMdWarning } from "react-icons/io";

const BankCall = () => {
  return (
    <div className="text-white text-[20px] flex justify-center items-center gap-[5px] h-[100%]">
      <IoMdWarning size={18} color="yellow" />
      <div>Your meeting room is watched on other tab or browser!</div>
    </div>
  );
};

export { BankCall };
